import React, { useState } from 'react';
import styled from 'styled-components';
import { cores } from '../../../../styles/styleUtils';

const CalendarContainer = styled.div`
  background-color: ${cores.cinzaClaro};
  border: 1px solid ${cores.cinzaClaro};
  border-radius: 5px;
  padding: 16px;
  margin-top: 16px;
`;

const CalendarTitle = styled.h3`
  color: ${cores.cinzaMedio};
  font-size: 1.1rem;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const MonthControls = styled.div`
  display: flex;
  gap: 10px;

  button {
    padding: 4px 8px;
    background-color: ${cores.laranja};
    color: ${cores.textoClaro};
    border: none;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
      background-color: ${cores.laranjaEscuro};
    }
  }
`;

const CalendarWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
  margin-top: 10px;
`;

const DayHeader = styled.div`
  font-size: 0.8rem;
  color: ${cores.cinzaMedio};
  text-align: center;
`;

const Day = styled.div`
  padding: 8px;
  text-align: center;
  border-radius: 3px;
  font-size: 0.9rem;
  color: ${cores.chumbo};
  cursor: pointer;

  &:hover {
    background-color: ${cores.cinzaClaro};
  }
`;

const ReceivableDay = styled(Day)`
  color: rgb(248, 11, 11);
  font-weight: bold;
`;

const CurrentDay = styled(Day)`
  background-color: ${cores.laranja};
  color: ${cores.textoClaro};
`;

const OsCalendarSection = ({ title, receivableDates, onDoubleClick }) => {

  const today = new Date();
  const [currentMonth, setCurrentMonth] = useState(today.getMonth());
  const [currentYear, setCurrentYear] = useState(today.getFullYear());

  const daysOfWeek = ['Do', 'Se', 'Te', 'Qa', 'Qi', 'Se', 'Sa'];

  const getDaysInMonth = (month, year) => new Date(year, month + 1, 0).getDate();

  const firstDayOfWeek = new Date(currentYear, currentMonth, 1).getDay();
  const totalDays = getDaysInMonth(currentMonth, currentYear);

  const handlePrevMonth = () => {
    if (currentMonth === 0) {
      setCurrentMonth(11);
      setCurrentYear((prev) => prev - 1);
    } else {
      setCurrentMonth((prev) => prev - 1);
    }
  };

  const handleNextMonth = () => {
    if (currentMonth === 11) {
      setCurrentMonth(0);
      setCurrentYear((prev) => prev + 1);
    } else {
      setCurrentMonth((prev) => prev + 1);
    }
  };

  const isReceivableDate = (day) =>
    receivableDates?.some((d) => d.dia === day && d.mes - 1 === currentMonth && d.ano === currentYear);

  const isToday = (day) =>
    day === today.getDate() && currentMonth === today.getMonth() && currentYear === today.getFullYear();

  return (
    <CalendarContainer>
      <CalendarTitle>
        {title} - {`${currentMonth + 1}`.padStart(2, '0')}/{currentYear}
        <MonthControls>
          <button onClick={handlePrevMonth}>&lt;</button>
          <button onClick={handleNextMonth}>&gt;</button>
        </MonthControls>
      </CalendarTitle>
      <CalendarWrapper>
        {daysOfWeek.map((day, index) => (
          <DayHeader key={index}>{day}</DayHeader>
        ))}

        {/* Preenche os dias vazios antes do primeiro dia do mês */}
        {Array.from({ length: firstDayOfWeek }).map((_, idx) => (
          <div key={`empty-${idx}`} />
        ))}

        {Array.from({ length: totalDays }, (_, i) => {
          const day = i + 1;
          let DayComponent = Day;

          if (isReceivableDate(day)) {
            DayComponent = ReceivableDay;
          } else if (isToday(day)) {
            DayComponent = CurrentDay;
          }

          return (
            <DayComponent key={day} onDoubleClick={() => onDoubleClick?.(new Date(currentYear, currentMonth, day))}>
              {day}
            </DayComponent>
          );
        })}
      </CalendarWrapper>
    </CalendarContainer>
  );
};

export default OsCalendarSection;